<template>
  <div id="app">
    <div v-wechat-title="title"></div>
    <template v-if="white_list.indexOf($route.path) >= 0">
      <router-view />
    </template>
    <template v-else>
      <Head></Head>
      <router-view :key="key" />
      <Footer :hideNav="hideNav"></Footer>
      <el-backtop :bottom="300">
        <div class="backtop_wrap">
          <el-popover placement="left-start" trigger="hover">
            <div class="qrcode_wrap">
              <div>微信扫一扫</div>
              <img
                :src="`https://e-zhongbiao.com/${$store.getters.config.QRCODE.value}`"
                alt=""
              />
            </div>
            <div slot="reference" class="top_item">
              <i class="el-icon-menu"></i>
              <div>二维码</div>
            </div>
          </el-popover>
          <el-popover placement="left-start" trigger="hover">
            <div class="service">
              <div
                class="fc"
                v-for="item in $store.getters.config.customer_qq1.value.split(
                  ';'
                )"
                :key="item"
              >
                <img src="@/assets/images/index/icon_qq.png" alt="" />
                <span>{{ item }}</span>
              </div>
            </div>
            <div slot="reference" class="top_item">
              <i class="el-icon-chat-dot-square"></i>
              <div>客服</div>
            </div>
          </el-popover>
          <div class="top_item pointer">
            <i class="el-icon-top"></i>
            <div>置顶</div>
          </div>
        </div>
      </el-backtop>
    </template>
  </div>
</template>

<script>
import Head from "@/components/Head/Head.vue";
import Footer from "@/components/Footer/Footer.vue";
import { getToken } from "@/utils/auth";
import { httpGet } from "@/apis";
import store from "./store";
import _ from "lodash";

var timer = null;

export default {
  name: "App",
  data() {
    return {
      hideNav: false,
      white_list: [
        "/login",
        "/register",
        "/user_agreement",
        "/forgot_password",
        "/join_membership",
        "/404",
      ],
      title: "",
    };
  },
  components: { Head, Footer },
  computed: {
    key() {
      return this.$route.fullPath;
    },
  },
  watch: {
    $route(to, from) {
      // this.initTimer();
      this.hideNav = this.white_list.indexOf(to.path) >= 0;
    },
  },
  mounted() {
    let self = this;

    // if (self.$store.getters.seo_list.length === 0) {
    self.getSeoConfig();
    // }
    if (self.$store.getters.navigation.length === 0) {
      self.getNavbar("nav1");
    }
    if (self.$store.getters.footer_navigation.length === 0) {
      self.getNavbar("nav2");
    }
    if (self.$store.getters.help_center.length === 0) {
      self.getNavbar("nav3");
    }
    self.initConfig();
    self.title = self.$store.getters.config.web_name.value;
    // if (_.isEmpty(self.$store.getters.config)) {
    //   self.initConfig();
    // } else {
    //   self.title = self.$store.getters.config.web_name.value;
    // }
    if (_.isEmpty(self.$store.getters.provinceList)) {
      self.getProvince();
    }

    // 已登录，刷新用户信息
    if (getToken()) {
      store.dispatch("user/getInfo");
    } else {
      store.dispatch("user/logout");
    }

    clearInterval(timer);
    localStorage.removeItem("loginFirstTime");
  },
  methods: {
    initTimer() {
      const that = this;
      // 获取登录时间
      const loginFirstTime = localStorage.getItem("loginFirstTime");
      if (loginFirstTime) {
        // 创建计时器
        timer = setInterval(() => {
          // 如果登录时间存在且时间差超过三小时，则退出登录
          if (
            loginFirstTime &&
            new Date().getTime() - loginFirstTime >= 24 * 60 * 60 * 1000
          ) {
            // 执行退出登录操作
            that.$store.dispatch("user/logout");
            that.$router.push("/login");
          }
        }, 60 * 1000); // 每分钟检查一次
      } else {
        clearInterval(timer);
      }
    },
    async getSeoConfig() {
      const res = await httpGet("/api/information/page_seo");
      if (res.code === 200) {
        this.$store.dispatch("app/toggleSeoList", res.data);
      } else {
        this.$message.error(res.message);
      }
    },
    async getNavbar(type) {
      const res = await httpGet("/api/information/navigation", { type });
      if (res.code === 200) {
        if (type === "nav1") {
          this.$store.dispatch("app/toggleNavigation", res.data);
        } else if (type === "nav2") {
          this.$store.dispatch("app/toggleFooterNavigation", res.data);
        } else {
          this.$store.dispatch("app/toggleHelpCenter", res.data);
        }
      } else {
        this.$message.error(res.message);
      }
    },
    async getCategory() {
      const res = await httpGet("/api/order.Vip/categoryList");
      if (res.code === 200) {
        this.category_list = res.data;
      } else {
        this.$message.error(res.message);
      }
    },
    async initConfig() {
      const res = await httpGet("/api/Index/configList");
      if (res.code === 200) {
        this.$store.dispatch("app/toggleConfig", res.data);
        this.title = this.$store.getters.config.web_name.value;
      } else {
        this.$message.error(res.message);
      }
    },
    async getProvince() {
      const res = await httpGet("/api/Index/provinceList");
      if (res.code === 200) {
        this.$store.dispatch("app/toggleProvinceList", res.data);
      } else {
        this.$message.error(res.message);
      }
    },
  },
  beforeDestroy() {
    //在网页销毁前或者离开页面前清除定时器和解绑事件
    clearInterval(timer);
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-backtop {
  justify-content: center;
  width: 58px;
  height: 220px;
  background: #ffffff;
  border-radius: 0;
  box-shadow: 0px 0px 14px 0px rgba(0, 0, 0, 0.1);

  .backtop_wrap {
    height: 100%;
    font-size: 12px;
    font-family: AppleSystemUIFont;
    color: #909399;
    line-height: 15px;

    .top_item {
      padding: 20px 0 16px;
      text-align: center;
      border-bottom: 1px solid #dcdfe6;

      i {
        font-size: 18px;
        margin-bottom: 4px;
      }
    }

    .top_item:hover {
      color: #0f8cff;
    }

    > .top_item:last-child {
      border-bottom: 0;
    }
  }
}

.qrcode_wrap {
  font-size: 12px;
  font-family: AppleSystemUIFont;
  color: #303133;
  line-height: 15px;
  text-align: center;

  img {
    width: 88px;
    height: 88px;
    margin-top: 10px;
  }
}

.service {
  display: flex;
  flex-wrap: wrap;
  width: 200px;
}

.service > div {
  width: 100px;
  justify-content: center;
  margin-bottom: 8px;
  font-size: 12px;
  font-family: AppleSystemUIFont;
  color: #303133;
  line-height: 15px;

  img {
    width: 16px;
    height: 16px;
    margin-right: 4px;
  }

  span {
    cursor: pointer;
  }
}

.service > div:hover {
  color: #0f8cff;
  text-decoration: underline;
}

.service > div:last-child {
  margin-bottom: 0;
}

/deep/ .el-pagination {
  .more + .number {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue